import type { IconNode } from '../types';

/**
 * @name letter-m
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAyMFY0LjI1M2EuMjUuMjUgMCAwMS40NTQtLjE0NGw2LjcyNyA5LjQ2N2ExIDEgMCAwMDEuNjMgMGw2LjczNS05LjQ2OGEuMjUuMjUgMCAwMS40NTQuMTQ1VjIwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/letter-m
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterM: IconNode = [
  [
    'path',
    {
      d: 'M4 20V4.253a.25.25 0 01.454-.144l6.727 9.467a1 1 0 001.63 0l6.735-9.468a.25.25 0 01.454.145V20',
    },
  ],
];

export default LetterM;
